import * as React from 'react';

import ChevronDown from '../icons/24/arrow-down';
import ChevronUp from '../icons/24/arrow-up';
import Chip from '../chip/chip';
import Text from '../text';
import Link from '../link';
import Collapse from '../collapse';

import useEvent from '../hooks/use-event';

import { ChipSelected as Props } from './chip-selected.types';

const ChipSelected: React.FC<Props> = ({
  resetSelected,
  description,
  hideSelected,
  maxChipsToShow = 41,
  showSelected,
  chips,
}) => {
  const [expandedSelectedValues, setExpandedSelectedValues] =
    React.useState(false);

  const [heightOfCollapse, setHeightOfCollapse] = React.useState<
    number | undefined
  >(0);
  const divRef = React.useRef<HTMLDivElement>(null);

  const updateSize = () => {
    if (divRef && divRef.current) {
      setHeightOfCollapse(divRef.current.clientHeight);
    }
  };

  useEvent('resize', updateSize);

  React.useEffect(() => {
    if (divRef && divRef.current) {
      setHeightOfCollapse(divRef.current.clientHeight);
    }
  }, [divRef]);

  const toggleShowMore = () => {
    setExpandedSelectedValues(prevState => !prevState);
  };

  return chips ? (
    <div className="chip-selected__selected-options-wrapper">
      <div className="chip-selected__clear-all-button">
        <Text>{description}</Text>
        <Link {...resetSelected} />
      </div>
      <div>
        <Collapse
          className="chip-selected__collapse"
          isOpen={expandedSelectedValues}
        >
          <div className="chip-selected__selected-options" ref={divRef}>
            {chips.map(chip => (
              <Chip {...chip} key={chip.text} />
            ))}
          </div>
        </Collapse>

        {heightOfCollapse && heightOfCollapse > maxChipsToShow ? (
          <button
            type="button"
            className="chip-selected__expand"
            onClick={toggleShowMore}
          >
            {expandedSelectedValues ? (
              <>
                <Text
                  elementName="span"
                  size={Text.sizes.small}
                  className="chip-selected__expand-text"
                >
                  {hideSelected}
                </Text>
                <ChevronUp />
              </>
            ) : (
              <>
                <Text
                  elementName="span"
                  size={Text.sizes.small}
                  className="chip-selected__expand-text"
                >
                  {showSelected}
                </Text>
                <ChevronDown />
              </>
            )}
          </button>
        ) : null}
      </div>
    </div>
  ) : null;
};

export default ChipSelected;
